// Country names as the people sheets write them → the standard two-letter code the People pages
// show (2026-10-14): "U. Zurich, Switzerland" → "U. Zurich, CH". ISO 3166-1 alpha-2, except the
// UK (ISO: GB). Started from the 2026 sheets; add a spelling here as it comes up.

const COUNTRY_CODES = {
  AU: ["Australia"],
  CA: ["Canada"],
  CH: ["Switzerland"],
  CZ: ["Czechia", "Czech Republic", "Czech"],
  DE: ["Germany"],
  FR: ["France"],
  IT: ["Italy"],
  NL: ["Netherlands", "The Netherlands"],
  PL: ["Poland"],
  SA: ["Saudi Arabia"],
  UK: ["UK", "United Kingdom", "Great Britain"],
  US: ["USA", "US", "United States", "United States of America"]
};

const CODE_BY_NAME = new Map(Object.entries(COUNTRY_CODES).flatMap(([code, names]) => {
  return names.map((name) => [name.toLowerCase(), code]);
}));

// "Czech Republic" → "CZ"; "" when the name isn't listed
export function getCountryCode(name) {
  return CODE_BY_NAME.get(String(name || "").trim().toLowerCase()) || "";
}

// one affiliation: its last part, if a listed country, becomes the code
function getWithCode(affiliation) {
  const index = affiliation.lastIndexOf(",");
  if (index === -1) return affiliation;
  const code = getCountryCode(affiliation.slice(index + 1));
  return code ? `${affiliation.slice(0, index)}, ${code}` : affiliation;
}

// "U. Zurich, Switzerland; TU Munich, Germany" → "U. Zurich, CH; TU Munich, DE"; anything not
// listed stays as written
export function getAffiliationWithCodes(affiliation) {
  if (!affiliation) return affiliation;
  return String(affiliation).split(/\s*;\s*/).map(getWithCode).join("; ");
}
